import React from 'react';

import { FlexLayout } from '@zapier/common-components';
import {
  ColorName,
  Icon,
  IconName,
  Text,
  Typography,
} from '@zapier/design-system';

export type FeatureData = {
  /**
   * A string representing the name of icon to display. Must match a name listed in the ZDS `Icon` component.
   **/
  iconName: IconName;
  /**
   * The text to display next to the icon.
   **/
  label: string;
};

export type FeatureDisplayProps = {
  /**
   * The weight of the label text.
   *
   * @default 400
   */
  fontWeight?: 400 | 600 | 700 | 800;
  /**
   * The color of the icon.
   *
   * @default 'black'
   */
  iconColor?: ColorName;
  /**
   * The size of the icon.
   *
   * @default 25
   */
  iconSize?: number;
  /**
   * The type (effectively the "style") of text to render. One of a list of
   * preset types, which correspond exactly to the Zapier Design System.
   *
   * @default 'bodyText900'
   */
  textType?: keyof typeof Typography;
};

type FeatureProps = FeatureDisplayProps & FeatureData;

export const Feature = ({
  fontWeight = 400,
  iconColor = 'black',
  iconName,
  iconSize = 25,
  label,
  textType = 'bodyText900',
}: FeatureProps) => (
  <FlexLayout gutter="extraSmall" wrap="nowrap">
    <Icon color={iconColor} name={iconName} size={iconSize} />
    <Text fontWeight={fontWeight} type={textType}>
      {label}
    </Text>
  </FlexLayout>
);
